import {
    SimplePresentation
} from "../../core/winpresentation/SimplePresentationRunner";
import {FireInTheHole2} from "../FireInTheHole2";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FITH2Symbol} from "../symbols/FITH2Symbol";
import {gsap} from "gsap";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";

export class WinCapPresentation implements SimplePresentation {
    name: string = "WinCapPresentation";
    private _flowStateController: FlowStateController;
    shouldRun(): boolean {
        return FireInTheHole2.model.gameData.brokeTheBank;
    }

    start(controller: FlowStateController): void {
        this._flowStateController = controller;
        const tl = gsap.timeline(),
            startTime: number = 0,
            shakeDuration:number = 3;
        tl.add(()=>{
            FITH2SoundManager.stopAmbientLoop();
            FITH2SoundManager.playSound("capWinIntro")
        }, startTime);
        for (let i: number = 0; i < 6; i++) {
            FireInTheHole2.reelArea.allReels[i].reelView.getAllSymbols().forEach((sym: FITH2Symbol) => {
                tl.add(sym.getShakeAnimation({duration:shakeDuration, x:4, y:1}), startTime);
            });
        }
        tl.add(FireInTheHole2.winCapScreen.show(() => this.complete()));
    }

    public complete():void {
        this._flowStateController.finish();
        FireInTheHole2.keypadPlugin.setZeroBetSpinCounter(-1);
        FireInTheHole2.keypadPlugin.show();
        FireInTheHole2.setMode(FireInTheHole2.model.data.nextMode);
    }
}